"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNumberFormat = require("react-number-format");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _styles = require("@mui/material/styles");
var _excluded = ["inputRef", "onChange"];
var StyledTextField = (0, _styles.styled)(_TextField["default"])(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiInputBase-root': {
      fontFamily: '"AvenirLTPro-Book", sans-serif',
      fontWeight: "lighter",
      color: theme.palette["default"].contrastText,
      letterSpacing: "0.14994px"
    },
    "& .MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-error):before": {
      borderColor: theme.palette.custom.textFieldHover
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-error):before": {
      borderColor: theme.palette.custom.textFieldHover,
      borderBottomWidth: "2px"
    }
  };
});

/**
 *
 * @param {*} props
 */
var PhoneFormatCustom = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var inputRef = props.inputRef,
    onChange = props.onChange,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.PatternFormat, (0, _extends2["default"])({}, other, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          value: values.value
        }
      });
    },
    format: "(###) ###-####"
    // this prop converts the value from a string to a number without setting the value as values.formattedValue which looks weird when typing in to the field
    ,
    valueIsNumericString: true,
    mask: "_"
  }));
});

/**
 *
 * @param {*} props
 */
var PhoneInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(StyledTextField, {
    id: props.id || props.testid,
    ref: ref,
    select: props.select,
    autoFocus: props.autoFocus,
    autoComplete: props.autoComplete || "tel",
    error: props.error,
    label: props.label,
    value: props.value,
    margin: props.margin || 'normal' // none, dense, or normal
    ,
    onChange: props.onChange,
    onKeyPress: props.onKeyPress,
    onBlur: props.onBlur,
    fullWidth: props.fullWidth,
    helperText: props.helperText || props.error,
    InputProps: {
      inputComponent: PhoneFormatCustom
    },
    sx: {
      backgroundColor: props.disabled ? '#f7f7f7' : null,
      letterSpacing: "0.14994px"
    },
    required: props.required,
    variant: props.variant || 'standard',
    disabled: props.disabled
  });
});
var _default = exports["default"] = PhoneInput;